<template>
  <div class="introduce">
    <div class="nav">
        <div class="content">
          <i @click="goBack()"></i>
          <span @click="customer()">联系客服</span>
        </div>
    </div>
    <div class="header">
      <div class="introduce_txt"></div>
    </div>
    <div class="block">
      <div class="title"><span>1</span><span>为什么我升级后手机内有两个同款APP？</span></div>
      <div class="content">
        答：为了更好的给广大赚友们提供更高效的赚钱服务，本次产品全面升级，升级后只需保留最新的网赚产品即可，老版本可直接卸载。
      </div>
    </div>

    <div class="block">
      <div class="title"><span>2</span><span>新的app我之前赚的钱还在吗？</span></div>
      <div class="content">
        答：新的APP除了升级部分服务外没有其他变化，您的账户和余额不会受到任何影响。
      </div>
    </div>

    <div class="block">
      <div class="title"><span>3</span><span>为什么我的现金余额不见了？</span></div>
      <div class="content">
        <img src="~@/assets/images/explain_1.png"/>
        答：如果新版本中余额没有同步过来，请联系客服处理；
      </div>
    </div>

    <div class="block">
      <div class="title"><span>4</span><span>新APP里面ID和老APP的ID不一样怎么办？</span></div>
      <div class="content">
        答：请再打开老版APP，复制弹窗内的用户ID，连同新APP的用户ID一起提供给客服，客服会帮您处理。
      </div>
      <div class="split_line"></div>
      <div class="content">
        复制老版APP的用户ID
        <img src="~@/assets/images/explain_2.png" class="top_margin"/>
      </div>
      <div class="content">
        复制新版APP的用户ID
        <img src="~@/assets/images/explain_3.png" class="top_margin" style="margin-bottom: 0"/>
      </div>
    </div>

    <div class="block non_margin_bottom">
      <div class="title"><span>5</span><span>升级有什么福利吗？</span></div>
      <div class="content">
        答：当然有！黄金周榜奖励翻倍，最高可拿400元，详情可进入周榜活动板块查看！
        <img src="~@/assets/images/explain_4.png" class="top_margin" style="margin-bottom: 0"/>
      </div>
    </div>

  </div>
</template>

<style>
  body {
    background: #FFF;
  }
</style>

<style scoped>
  .nav {
    display: block;
    width: 100%;
    height: 0.22rem;
    color: #F5F7FA;
    position: fixed;
    z-index: 98;
    top: 0.3rem;
  }
  .nav .content {
    display: flex;
    width: 3.43rem;
    padding: 0 .16rem;
    height: 0.22rem;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .nav .content i {
    float: left;
    width: 0.17rem;
    height: 0.17rem;
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(45deg);
    overflow: hidden;
  }
  .nav .content span {
    float: right;
    font-size: 16px;
    color: #FFF;
  }
  .block {
    display: block;
    width: 3.43rem;
    margin: 0 auto;
    background: #FFF;
    margin-bottom: .4rem;
    overflow: hidden;
  }
  .block .title {
    display: flex;
    font-size: 16px;
    color: #222222;
    margin-bottom: .2rem;
    align-items: center;
  }
  .block .title span:first-child {
    display: inline-block;
    width: .18rem;
    height: .18rem;
    background: #FA5F00;
    color: #FFF;
    font-size: 12px;
    text-align: center;
    line-height: .18rem;
    border-radius: 100%;
    overflow:hidden;
  }
  .block .title span:last-child {
    display: inline-block;
    margin-left: .04rem;
  }
  .block .content {
    display: block;
    width: 100%;
    font-size: 16px;
    color: #444444;
  }
  .block .content img {
    display: inline-block;
    width: 100%;
    margin-bottom: .2rem;
  }
  .block .content img.top_margin {
    margin-top: .1rem;
  }
  .non_margin_bottom {
    margin-bottom: 0;
  }
  .block .split_line {
    display: block;
    clear: both;
    width: 100%;
    height: .2rem;
    overflow: hidden;
  }
  .header {
    display: block;
    width: 100%;
    height: 2.39rem;
    background: url('~@/assets/images/explain_banner.png') no-repeat;
    background-size: 3.75rem 2.39rem;
    margin-bottom: .3rem;
    overflow: hidden;
  }
</style>

<script>

export default {
  methods: {
    goBack: function () {
      window.injectedObject.setJsContent('closeWebview', '')
    },
    customer: function () {
      window.injectedObject.setJsContent('qqservice', '3007381093')
    }
  }
}
</script>